import { SelectListItem } from "../models/utilities/selectlist-item";
import { IApplicationState } from "../store/IApplicationState";
import { AppUtils } from "../utils/app-utils";
import { AssetSearchFilters } from "./models/filters/asset-search-filters";
import { ContainerSearchFilters } from "./models/filters/container-search-filters";
import { DeliveryPlanningFilters } from "./models/filters/delivery-planning-filters";
import { DriverSearchFilters } from "./models/filters/driver-search-filters";
import { PickupSearchFilters } from "./models/filters/pickup-search-filters";
import { TruckSearchFilters } from "./models/filters/truck-search-filters";

// Selectors

/**
 * Get the cached params or return a new instance
 * @param state The redux state
 */
export const getAssetSearchFilters = (state : IApplicationState) : AssetSearchFilters => {
    const cached = state.transportation.assetSearchFilters;
    return AppUtils.IsEmpty(cached)
                ? new AssetSearchFilters()
                : cached!;
};

/**
 * Get the cached params or return a new instance
 * @param state The redux state
 */
export const getDriverSearchFilters = (state : IApplicationState) : DriverSearchFilters => {
    const cached = state.transportation.driversSearchFilters;
    return AppUtils.IsEmpty(cached)
                ? new DriverSearchFilters()
                : cached!;
};

/**
 * Get the cached params or return a new instance
 * @param state The redux state
 */
export const getTruckSearchFilters = (state: IApplicationState, columns: string[] = [], filters: string[] = []) : TruckSearchFilters => {
    const cached = state.transportation.truckSearchFilters;
    return AppUtils.IsEmpty(cached)
                ? new TruckSearchFilters(columns, filters)
                : cached!;
};

/**
 * Get the cached params or return a new instance
 * @param state The redux state
 */
export const getPickupSearchFilters = (state : IApplicationState) : PickupSearchFilters => {
    const cached = state.transportation.pickupsSearchFilters;
    return AppUtils.IsEmpty(cached)
                ? new PickupSearchFilters()
                : cached!;
};

/**
 * Get the cached params or return a new instance
 * @param state The redux state
 */
export const getContainerSearchFilters = (state: IApplicationState, columns: string[] = [], filters: string[] = []) : ContainerSearchFilters => {
    const cached = state.transportation.containerSearchFilters;
    return AppUtils.IsEmpty(cached)
                ? new ContainerSearchFilters(columns, filters)
                : cached!;
};

/**
 * Get the cached params or return a new instance
 * @param state The redux state
 */
export const getCommunicationsTruckSearchFilters = (state: IApplicationState, columns: string[] = [], filters: string[] = []): TruckSearchFilters => {
    const cached = state.transportation.communicationsTruckSearchFilters;
    return AppUtils.IsEmpty(cached)
        ? new TruckSearchFilters(columns, filters)
        : cached!;
};

/**
 * Get the cached params or return a new instance
 * @param state The redux state
 */
export const getCommunicationsContainerSearchFilters = (state: IApplicationState, columns: string[] = [], filters: string[] = []): ContainerSearchFilters => {
    const cached = state.transportation.communicationsContainerSearchFilters;
    return AppUtils.IsEmpty(cached)
        ? new ContainerSearchFilters(columns, filters)
        : cached!;
};

/**
 * Get the cached params or return a new instance
 * @param state The redux state
 */
export const getDeliveryPlanningFilters = (state : IApplicationState) : DeliveryPlanningFilters => {
    const cached = state.transportation.deliveryPlanningFilters;
    return AppUtils.IsEmpty(cached)
                ? new DeliveryPlanningFilters()
                : cached!;
};

/**
 * Return a hardcoded select list of carriers
 * @param state The redux state
 */
export const carrierSelectList = (): Array<SelectListItem<string>> => {
    const carrierList: Array<SelectListItem<string>> = [];
    carrierList.push(new SelectListItem<string>({ id: 1, name: 'Hub Group' }));
    carrierList.push(new SelectListItem<string>({ id: 2, name: 'JB Hunt' }));
    carrierList.push(new SelectListItem<string>({ id: 3, name: 'Ex Works' }));
    carrierList.push(new SelectListItem<string>({ id: 4, name: 'Cano & Sons' }));
    carrierList.push(new SelectListItem<string>({ id: 5, name: 'N.C.D.C.' }));
    carrierList.push(new SelectListItem<string>({ id: 6, name: 'Empty Pockets LLC' }));
    carrierList.push(new SelectListItem<string>({ id: 7, name: 'Herrington Transportation' }));
    carrierList.push(new SelectListItem<string>({ id: 8, name: 'Chesterville Trucking' }));
    carrierList.push(new SelectListItem<string>({ id: 9, name: 'G&E Transport' }));
    carrierList.push(new SelectListItem<string>({ id: 10, name: 'Cornerstone Logistics' }));
    carrierList.push(new SelectListItem<string>({ id: 11, name: 'Stevens Trucking' }));
    carrierList.push(new SelectListItem<string>({ id: 12, name: 'West Motor Freight' }));
    carrierList.push(new SelectListItem<string>({ id: 13, name: 'Alton Delivery Service' }));
    carrierList.push(new SelectListItem<string>({ id: 14, name: 'APL Logistics' }));
    carrierList.push(new SelectListItem<string>({ id: 15, name: 'Total Quality Logistics' }));
    carrierList.push(new SelectListItem<string>({ id: 16, name: 'XPO' }));
    carrierList.push(new SelectListItem<string>({ id: 17, name: 'ABF Freight System' }));
    carrierList.push(new SelectListItem<string>({ id: 18, name: 'Medallion' }));

    return carrierList;
};

export const carrierMap = (carrierId : any) : any  => {

    if (!carrierId) {
        return '';
    }

    const carrierList : any = {
        1: { name: 'Hub Group'},
        2: { name: 'JB Hunt'},
        3: { name: 'Ex Works'},
        4: { name: 'Cano & Sons'},
        5: { name: 'N.C.D.C.' },
        6: { name: 'Empty Pockets LLC' },
        7: { name: 'Herrington Transportation' },
        8: { name: 'Chesterville Trucking' },
        9: { name: 'G&E Transport' },
        10: { name: 'Cornerstone Logistics' },
        11: { name: 'Stevens Trucking' },
        12: { name: 'West Motor Freight' },
        13:  { name: 'Alton Delivery Service' },
        14:  { name: 'APL Logistics' },
        15: { name: 'Total Quality Logistics' },
        16: { name: 'XPO' },
        17: { name: 'ABF Freight System' },
        18: { name: 'Medallion' }
    };

    return carrierList[carrierId].name;
};
